/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

interface IMilTitle {
    className: string;
    text: string;
}

export const MilTitle: React.FC<IMilTitle> = ({ text, className }) => (
    <span className={className}>
        {` `}
        {text}
        {` `}
    </span>
);
